var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"appointOrder-default"},[_c('div',{staticClass:"text-tip"},[_c('p',[_c('span',{staticClass:"refresh-btn",on:{"click":_vm.refresh}},[_c('span',{staticClass:"iconfont iconshuaxin"}),_c('span',[_vm._v("刷新页面")])])]),_c('p',{staticClass:"more-his"},[_c('span',{on:{"click":_vm.viewMore}},[_vm._v("查看历史记录>>")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }